import React from "react";
import { BookingLogsModel } from "app/models";
import UserAvatar from "app/components/UserAvatar";
import styles from "./styles.module.scss";
import { BookingLogModel } from "app/models/BookingLogModel";
import useCalendarPreferences from "app/utils/hooks/useCalendarPreferences";

interface Props {
  bookingLog: BookingLogsModel;
  isCoach: boolean;
}

const SingleBookingLog = ({ bookingLog, isCoach }: Props) => {
  const { preferences } = useCalendarPreferences();
  const bookingLogObject = new BookingLogModel(bookingLog, isCoach, preferences);

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.left_side}>
          <UserAvatar
            altName="user avatar"
            sizeHeight={44}
            sizeWidth={44}
            className={styles.avatar}
            srcName={bookingLogObject.getPictureUrl()}
            userName={bookingLogObject.getFirstUserName()}
          />
          <div className={styles.info}>
            <p className={styles.user_name}>
              {bookingLogObject.getUsersNames()}
            </p>
            <p className={styles.datetime}>
                {bookingLog.createdAt && bookingLogObject.formatFullDateWithTimeZone()}
            </p>
          </div>
        </div>
        <div className={styles.action_icon}>
          <i className={bookingLogObject.getIcoType()} />
        </div>
      </div>
      <hr />
      <div className={styles.log_message}>
        {bookingLogObject.highlightMessageParts()}
      </div>
    </div>
  );
};

export default SingleBookingLog;
